import React, { FunctionComponent, ReactNode } from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { formLayout } from '~/components/ui';
import { AUTH_TITLE_ID } from '../layout/AuthCard';
import SubmitButton from './SubmitButton';
import { emailRules } from './authRules';
import styles from './authForm.module.scss';

export interface EmailFormModel {
  email: string;
}

interface EmailFormProps {
  name: string;
  initialEmail: string;
  submitLabel: string;
  busyLabel: string;
  busy: boolean;
  onSubmit: (email: string) => void;
  /** Komunikat nad formularzem (np. wygasły link). */
  notice?: ReactNode;
}

/** Formularz z jednym polem e-mail: link do logowania, przypomnienie hasła, potwierdzenie adresu. */
const EmailForm: FunctionComponent<EmailFormProps> = ({
  name,
  initialEmail,
  submitLabel,
  busyLabel,
  busy,
  onSubmit,
  notice,
}) => {
  const { t } = useTranslation('auth');

  return (
    <>
      {notice && <div className={styles.callout}>{notice}</div>}
      <Form<EmailFormModel>
        name={name}
        layout="vertical"
        requiredMark={false}
        scrollToFirstError={{ focus: true }}
        validateTrigger="onBlur"
        className={`${formLayout.form} ${styles.form}`}
        aria-labelledby={AUTH_TITLE_ID}
        initialValues={{ email: initialEmail }}
        onFinish={({ email }) => {
          if (!busy) onSubmit(email.trim());
        }}
      >
        <Form.Item name="email" label={t('auth:screens.field.email')} rules={emailRules(t)}>
          <Input
            type="email"
            autoComplete="email"
            aria-required="true"
            autoFocus={!notice}
            readOnly={busy}
          />
        </Form.Item>
        <SubmitButton label={submitLabel} busyLabel={busyLabel} busy={busy} />
      </Form>
    </>
  );
};

export default EmailForm;
